import { useSuspenseQuery } from '@tanstack/react-query';
import type { Rarity } from '@outdoria/types';
import { fetcher } from '../utils';
import { RARITY_TYPES_ALL } from '../queryKeys';

export const useGetRarityTypesAll = () => {
  const queryFn = async (): Promise<Rarity[]> => {
    const res = await fetcher(`/v2/rarity_types`);
    return res.json();
  };

  const {
    data = [],
    isLoading,
    isFetched,
    isError,
  } = useSuspenseQuery<Rarity[], unknown, Rarity[], string[]>({
    queryKey: RARITY_TYPES_ALL,
    queryFn,
  });

  return { data, isLoading, isFetched, isError };
};
